import { takeLatest, put } from 'redux-saga/effects';
import { deleteTaskSagaAction } from 'data/tasks/actions';
import { removeTaskFromSpaceTab } from '..';
import { deleteTaskFromSpaceTabSagaAction } from '../actions';
function* deleteTaskFromSpaceTabSaga({ payload }) {
    const { spaceTabId, taskId, projectId } = payload;
    yield put(removeTaskFromSpaceTab({
        spaceTabId,
        taskId
    }));
    yield put(deleteTaskSagaAction({
        projectId,
        taskId
    }));
}
export function* watchDeleteTaskFromSpaceTabSaga() {
    yield takeLatest(deleteTaskFromSpaceTabSagaAction.type, deleteTaskFromSpaceTabSaga);
}
